import { render, staticRenderFns } from "./column-config-icon.vue?vue&type=template&id=56c588f6"
import script from "./column-config-icon.vue?vue&type=script&lang=js"
export * from "./column-config-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports